import { useSelector } from 'react-redux'
import { useJackpotNavigation } from '@hooks/jackpot/useJackpotNavigation'
import JackpotCard from './JackpotCard'

// Owns the currency selector + navigation hook so JackpotCard stays pure
// render. Reused for both the Active card and every History row.
const JackpotCardController = ({ jackpot, viewType }) => {
  const currencyCode = useSelector((state) => state.wallet.displayCurrencyCode)
  const { onViewJackpot } = useJackpotNavigation()

  if (!jackpot) return null

  return (
    <JackpotCard
      jackpot={jackpot}
      currencyCode={currencyCode}
      onView={() => onViewJackpot(jackpot, viewType)}
    />
  )
}

export default JackpotCardController
